module.exports = __webpack_public_path__ + "img/small-metrika-pro.a0f1f968.svg";